/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DirectoryCardPlayerSource
 */
export interface DirectoryCardPlayerSource {
    /**
     * 
     * @type {string}
     * @memberof DirectoryCardPlayerSource
     */
    platform: DirectoryCardPlayerSourcePlatformEnum;
    /**
     * 
     * @type {string}
     * @memberof DirectoryCardPlayerSource
     */
    twitchChannelId?: string;
    /**
     * 
     * @type {string}
     * @memberof DirectoryCardPlayerSource
     */
    kickChannelSlug?: string;
    /**
     * 
     * @type {string}
     * @memberof DirectoryCardPlayerSource
     */
    youtubeChannelId?: string;
    /**
     * 
     * @type {string}
     * @memberof DirectoryCardPlayerSource
     */
    youtubeLiveId?: string;
    /**
     * Whether the source stream is currently live (drives autoplay vs offline-embed treatment)
     * @type {boolean}
     * @memberof DirectoryCardPlayerSource
     */
    isLive: boolean;
}


/**
 * @export
 */
export const DirectoryCardPlayerSourcePlatformEnum = {
    TWITCH: 'TWITCH',
    KICK: 'KICK',
    YOUTUBE: 'YOUTUBE'
} as const;
export type DirectoryCardPlayerSourcePlatformEnum = typeof DirectoryCardPlayerSourcePlatformEnum[keyof typeof DirectoryCardPlayerSourcePlatformEnum];


/**
 * Check if a given object implements the DirectoryCardPlayerSource interface.
 */
export function instanceOfDirectoryCardPlayerSource(value: object): value is DirectoryCardPlayerSource {
    if (!('platform' in value) || value['platform'] === undefined) return false;
    if (!('isLive' in value) || value['isLive'] === undefined) return false;
    return true;
}

export function DirectoryCardPlayerSourceFromJSON(json: any): DirectoryCardPlayerSource {
    return DirectoryCardPlayerSourceFromJSONTyped(json, false);
}

export function DirectoryCardPlayerSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): DirectoryCardPlayerSource {
    if (json == null) {
        return json;
    }
    return {
        
        'platform': json['platform'],
        'twitchChannelId': json['twitchChannelId'] == null ? undefined : json['twitchChannelId'],
        'kickChannelSlug': json['kickChannelSlug'] == null ? undefined : json['kickChannelSlug'],
        'youtubeChannelId': json['youtubeChannelId'] == null ? undefined : json['youtubeChannelId'],
        'youtubeLiveId': json['youtubeLiveId'] == null ? undefined : json['youtubeLiveId'],
        'isLive': json['isLive'],
    };
}

export function DirectoryCardPlayerSourceToJSON(json: any): DirectoryCardPlayerSource {
    return DirectoryCardPlayerSourceToJSONTyped(json, false);
}

export function DirectoryCardPlayerSourceToJSONTyped(value?: DirectoryCardPlayerSource | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'platform': value['platform'],
        'twitchChannelId': value['twitchChannelId'],
        'kickChannelSlug': value['kickChannelSlug'],
        'youtubeChannelId': value['youtubeChannelId'],
        'youtubeLiveId': value['youtubeLiveId'],
        'isLive': value['isLive'],
    };
}

